import * as React from "react";
import { toJS } from "mobx";
import { TravelersPicker } from "./TravelersPicker";
import { TravelersContentProps, Travelers } from "../typings";
import { LobErrorSummary } from "../../LobErrorSummary/LobErrorSummary";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading } from "uitk-react-text";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { locKeys } from "../l10n";

export const TravelersContent = (props: TravelersContentProps) => {
  const roomRefs: React.RefObject<HTMLHeadingElement>[] = [];
  const { invalidTokenKey, onChange, lobState } = props;
  const { validateTravelersField, validateInfantsPerTraveler, validateUnattendedInfantInLap, config } = lobState;
  const { formatText } = useLocalization();
  const [totalRoomRefs, setTotalRoomRefs] = React.useState<number>(0);
  const [travelers, setTravelers] = React.useState<Travelers>(toJS(props.travelers));
  const isTravelersValid = validateTravelersField!();
  const invalidToken =
    invalidTokenKey || lobState.nonHotelTravelersInvalidKey || lobState.hotelTravelersInvalidKey || "";
  const showError = !isTravelersValid && invalidToken !== "";
  const [errorLocArgs, setErrorLocArgs] = React.useState<any>([]);

  const { invalidNumberOfInfantPerTravelerMessageToken, invalidUnattendedInfantOnLapMessageToken } = props.config;

  const setAndSaveTravelers = (travelersData: Travelers) => {
    setTravelers(travelersData);
    onChange(travelersData);
  };

  React.useEffect(() => {
    const lastRoomRef = roomRefs[roomRefs.length - 1];
    if (!!lastRoomRef && !!lastRoomRef.current) {
      lastRoomRef.current.focus();
    }
    //handles each error loc args depending on validations
    if (invalidToken) {
      if (
        validateInfantsPerTraveler &&
        !validateInfantsPerTraveler() &&
        invalidToken === invalidNumberOfInfantPerTravelerMessageToken
      ) {
        setErrorLocArgs([config.travelers.minInfantPerTraveler, config.travelers.minAdultAge]);
      } else if (
        validateUnattendedInfantInLap &&
        !validateUnattendedInfantInLap() &&
        invalidToken === invalidUnattendedInfantOnLapMessageToken
      ) {
        setErrorLocArgs([config.travelers.minAdultAge]);
      } else {
        setErrorLocArgs([config.travelers.maxBookableTravelers]);
      }
    }
  }, [totalRoomRefs, showError]);

  return (
    <div aria-label={formatText(locKeys.roomPickerOpened)}>
      <Viewport>
        <ViewSmall>
          <>
            {showError && (
              <div className="all-x-padding-one all-t-padding-two">
                <LobErrorSummary
                  className="all-t-padding-two"
                  locHeadingToken={invalidToken}
                  locHeadingArgs={errorLocArgs}
                />
              </div>
            )}
          </>
        </ViewSmall>
        <ViewLarge>
          <div className="all-x-padding-one all-t-padding-two">
            <UitkHeading level={3} size={500}>
              {formatText(props.config.dialogTitleToken)}
            </UitkHeading>
            {showError && (
              <LobErrorSummary
                className="all-t-padding-two"
                locHeadingToken={invalidToken}
                locHeadingArgs={errorLocArgs}
              />
            )}
          </div>
        </ViewLarge>
      </Viewport>
      <TravelersPicker
        {...props}
        roomRefs={roomRefs}
        totalRoomRefs={totalRoomRefs}
        setTotalRoomRefs={setTotalRoomRefs}
        travelers={travelers}
        setTravelers={setAndSaveTravelers}
      />
    </div>
  );
};
